// extracted by mini-css-extract-plugin
export default {"block":"NavBarUser_block__3LxJh","logout_button":"NavBarUser_logout_button__Kjlmv"};